const skills = {
  title: "Skills",
  categories: [
    {
      name: "Programming Languages",
      skills: ["Python", "C", "C++", "Java", "R"]
    },
    {
      name: "Web Development",
      skills: ["JavaScript", "ReactJS"]
    },
    {
      name: "App Development",
      skills: ["Flutter"]
    },
    {
      name: "Database",
      skills: ["Firebase", "SQL", "SQLite"]
    },
    {
      name: "Artificial Intelligence",
      skills: ["PyTorch", "scikit-learn"]
    },
    {
      name: "Cloud",
      skills: ["Azure AI Services"]
    },
    {
      name: "Data Analytics Tools",
      skills: ["Looker Studio", "Power BI"]
    }
  ]
}

export default skills